        <div class="header-main ">
         <div class="container">
        <nav class="navbar navbar-new navbar-expand-lg navbar-light bg-white shadow">

                <!-- Logo -->
                <a class="navbar-brand logo-text" href="#">
                     <img src="/assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt="">
                </a>

                <!-- Toggle -->
                <button class="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarContent">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <!-- Menu -->
                <div class="collapse navbar-collapse" id="navbarContent">

                    <!-- Center Links -->
                <ul class="navbar-nav mx-auto nav-center-links">
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/')" (click)="goTo('/')">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/about-us')" (click)="goTo('/about-us')">About</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/our-services')" (click)="goTo('/our-services')">Services</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/products')" (click)="goTo('/products')">Pricing</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/job-finder')" (click)="goTo('/job-finder')">Jobs</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [class.active-menu]="isActive('/contact-us')" (click)="goTo('/contact-us')">Contact</a>
                    </li>
                </ul>

                    <!-- Right Buttons -->
                    <div class="nav-buttons ms-auto d-flex align-items-center">
                        <a class="btn login-style" (click)="goTo('/sign-in')">Login</a>
                    </div>

                </div>
        </nav>
    </div>
    </div>
